import { render } from "./ViewDemandeInscription.vue?vue&type=template&id=221388fa&ts=true"
import script from "./ViewDemandeInscription.vue?vue&type=script&lang=ts"
export * from "./ViewDemandeInscription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__